import DatosCliente from "../../../../EmitirFactura/Components/GeneracionFactura/DatosCliente"
import DatosProducto from "../../../../EmitirFactura/Components/GeneracionFactura/DatosProducto"
import TablaBienesServicios from "../../../../EmitirFactura/Components/GeneracionFactura/TablaBienesServicios"

export const SujetoExcluido = () => {
  return (
    <>
      <DatosCliente />
      <DatosProducto />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card'>
          <div className='w-layout-vflex card-content'>
            <TablaBienesServicios />
          </div>
        </div>
      </div>
    </>
  )
}
